import { Search, FileText, PenTool } from "lucide-react";
import { useTranslation } from "react-i18next";
import { MobileEditorialHeading } from "./mobile-editorial-heading";

export function MobileFeatures() {
  const { t } = useTranslation();
  const items = [
    { icon: Search, title: t("features.items.research.title"), desc: t("features.items.research.desc") },
    { icon: FileText, title: t("features.items.analysis.title"), desc: t("features.items.analysis.desc") },
    { icon: PenTool, title: t("features.items.drafting.title"), desc: t("features.items.drafting.desc") },
  ];
  return (
    <section id="features" className="mob-surface-0 px-5 py-16 text-white">
      <div className="mb-8 border-t border-white/10 pt-8">
        <MobileEditorialHeading
          index="01"
          eyebrow={t("features.eyebrow")}
          title={t("features.title")}
          subtitle={t("features.subtitle")}
        />
      </div>
      <ul className="space-y-3">
        {items.map((f) => {
          const Icon = f.icon;
          return (
            <li key={f.title} className="rounded-2xl border mob-hairline mob-surface-1 p-5 text-center">
              <span className="mx-auto mb-4 inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white text-black">
                <Icon className="h-[18px] w-[18px]" strokeWidth={2} />
              </span>
              <h3 className="mob-h3">{f.title}</h3>
              <p className="mob-body mt-2 mob-text-dim">{f.desc}</p>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
